export const PlayerData =[
    {   id:1,
        img:'http://www.gstatic.com/tv/thumb/persons/983712/983712_v9_ba.jpg',
        name:"Lionel Messi",
        country:"Argentina",
        club:"Barcelona",
        position:'stricker',
        salary:26000
    },

    
    {
        id:2,
        img:'https://upload.wikimedia.org/wikipedia/commons/8/8c/Cristiano_Ronaldo_2018.jpg',
        name:"Cristiano Ronaldo", 
        country:"Portugal",
        club:"Juventus",
        position:'stricker',
        salary:31000
     },

     
    {
        id:3,
        img:'https://mundoalbiceleste.com/wp-content/uploads/2020/04/20200428_112412_compress29.jpg',
        name:"Paulo Dybala",
        country:"Argentina",
        club:"Juventus",
        position:'stricker',
        salary:20000
     },

     
    {
        id:4,
        img:'https://upload.wikimedia.org/wikipedia/commons/b/bc/Bra-Cos_%281%29.jpg',
        name:"Neymar",
        country:"Brazil",
        club:"PSG",
        position:'stricker',
        salary:25000
     },

     
    {
        id:5,
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT92R5ZsSSZRUG28SdZ8IK9li9mQCQHPr_63Q&usqp=CAU',
        name:"Kylian Mbappé",
        country:"Franch",
        club:"PSG",
        position:'stricker',
        salary:25000
     },

     
    {
        id:6,
        img:'https://media.squawka.com/images/en/2019/08/25224016/antoine-griezmann-barcelona-2019-b.jpg',
        name:"Antoine Griezmann",
        country:"Franch",
        club:"barcelona",
        position:'stricker',
        salary:20000
     },

     
     {
        id:7,
        img:'http://t0.gstatic.com/images?q=tbn:ANd9GcRBF3nCh3mOVitzUbo5GZimMwpdGjL7hDQBt6KdATPLky7Tj8yPOW_nvaTVhgGZ',
        name:"Ansu Fati",
        country:"Spain",
        club:"barcelona",
        position:'stricker',
        salary:18000
     },

     
     {
        id:8,
        img:'https://medias.lequipe.fr/img-photo-jpg/ousmane-dembele-barcelona-november-27-2019-football-soccer-uefa-champions-league-group-f-m/1500000001328330/455:0%2C2175:1145-1000-666-70/2cc67.jpg',
        name:"Ousmane Dembélé",
        country:"Franch",
        club:"barcelona",
        position:'stricker',
        salary:22000
     },

     
     {
        id:9,
        img:'http://t2.gstatic.com/images?q=tbn:ANd9GcT0-UJJvLWa7-X6nJZzQDw7pI-nAzr1WvDQf1gdh_CPKtNvzSxiFAdSoePFoRX1',
        name:"Philippe Coutinho",
        country:"Brazil",
        club:"barcelona",
        position:'stricker',
        salary:23000
     },

     
     {
        id:10,
        img:'https://cdn.vox-cdn.com/thumbor/uU_QuFl6nGgfZb7swHvjaRyXnwg=/0x0:4000x2667/1200x800/filters:focal(1646x242:2286x882)/cdn.vox-cdn.com/uploads/chorus_image/image/68885251/1304390221.0.jpg',
        name:"Pedri",
        country:"Spain",
        club:"barcelona",
        position:'stricker',
        salary:18000
     },

     
     {
        id:11,
        img:'http://t1.gstatic.com/images?q=tbn:ANd9GcS55MeT-CgVRpn9DJ_ohQvCC2KIUktyhXPH1YYAcNCHWnt66m6_UDzY6jnqG2yc',
        name:"Frenkie de Jong",
        country:"Spain",
        club:"barcelona",
        position:'stricker',
        salary:19000
     },

     
     {
        id:12,
        img:'https://icdn.football-espana.net/wp-content/uploads/2020/06/Pique-Sevilla.jpg',
        name:"Gerard Piqué",
        country:"Spain",
        club:"barcelona",
        position:'stricker',
        salary:26000
     },

     
]